<template>
  <div class="guidance" v-loading="loading">
    <div class="search-box-page">
      <div class="search-item">
        <div class="search-content mb20">
          <el-input class="input-v2 input-round" v-model="queryParams.scope" :placeholder="$t('businessScenario')" suffix-icon="el-icon-search" clearable @change="handleSearch" />
        </div>
      </div>
    </div>
    <el-row :gutter="20" type="flex" justify="start" class="table-body">
      <el-col :span="10">
        <air-table
          ref="airTable"
          class="table-v2"
          :show-checkbox="false"
          :show-operation="false"
          :columns="columns"
          :data="list"
          align="center"
          @current-change="rowClick"
        >
        </air-table>
      </el-col>
      <el-col :span="10" v-if="row.name">
        <el-card class="current-content h100" shadow="never">
          <h4 class="card-title">{{ row.name }}</h4>
          <div class="search-result">
            <div class="informations">
              <div class="information-item">
                <div v-for="desc in getBusinessDescription" v-html="desc"></div>
              </div>
              <div class="information-item" v-if="row.document && row.document.length">
                <div class="title">模板：</div>
                <div class="document-template-name pt10 pointer" v-for="item in row.document" :key="item.name" @click="handleDownload(item)">
                  <el-image class="document-icon mr12" :src="documentIcon" fit="cover"></el-image>
                  <span class="color-primary-default cursor">{{ item.name }}</span>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
  import documentIcon from '@/assets/img/policy/document-icon.png';
  import * as api from '@/api/policy/policyLibrary';
  import { validatenull } from "@/util/validate";

  export default {
    name: "Guidance",
    data() {
      return {
        documentIcon,
        loading: false,
        queryParams:{
          scope: ''
        },
        columns: [
          { title: this.$t('businessScenario'), field: 'name', minWidth: 120, align: 'center'}
        ],
        list: [],
        row: {}
      }
    },
    created() {
      this.getData();
    },
    methods: {
      // 获取列表
      getData(isSearch = false) {
        this.loading = true;
        this.row = {};
        let params = {
          ...this.queryParams
        }
        api.businessList(params)
          .then(res => {
            this.loading = false;
            this.list = res.data.data || [];
            if (isSearch &&  res.data.data &&  res.data.data.length == 1) {
              this.row = res.data.data[0];
            }
          })
          .catch(error => {
            this.loading = false;
          })
      },
      // 检索
      handleSearch() {
        this.getData(true);
      },
      // 点击模板下载
      handleDownload({ link }) {
        window.open(link);
      },
      rowClick({ row }) {
        this.row = row;
      }
    },
    computed: {
      getBusinessDescription() {
        if (!validatenull(this.row)) {
          let { businessDescription } = this.row;
          businessDescription = businessDescription.replaceAll('如模板所示', '<span class="color-primary-default t-decoration-underline">如模板所示</span>');
          let businessDescriptionArr = businessDescription.split('\r\n');
          return businessDescriptionArr;
        } else {
          return [];
        }
      }
    }
  }
</script>

